var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingStatus),expression:"loadingStatus"}],staticClass:"global-loading"},[_c('img',{attrs:{"src":require("@/assets/global-loading.gif"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }